expect fun formatDecimalToCurrency(decimal: Double): String
fun Double.formatDecimalToCurrency(): String = formatDecimalToCurrency(this)